import {
  useUpdateWorkingTimeBookingStatus,
  WorkingTimeBookingDto,
  WorkingTimeImportStatus,
} from "@/orval/gen"
import { CancelButton } from "@components/Buttons"
import { FormButtonGroup } from "@components/form-button-group"
import { ModalProps, Modal, Button, Alert } from "@mantine/core"
import { useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { WorkingTimeBookingStack } from "@/routes/app/-components/working-time-bookings/WorkingTimeBookingStack"
import { showErrorNotification } from "@/utils/form-submission-notifications"

export function WorkingTimeBookingRequestDetailsModal({
  request,
  ...modalProps
}: { request: WorkingTimeBookingDto | undefined } & ModalProps) {
  const { t } = useTranslation("app_server")
  const queryClient = useQueryClient()
  const { mutateAsync: updateStatusAsync } = useUpdateWorkingTimeBookingStatus({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ["pagedWorkingTimeBookings"],
        })
        modalProps.onClose()
      },
      onError: showErrorNotification,
    },
  })
  const handleUpdateStatus = async (newStatus: WorkingTimeImportStatus) => {
    if (!request) return
    await updateStatusAsync({
      data: {
        workingTimeBookingId: request.workingTimeBookingId,
        newStatus: newStatus,
      },
    })
  }

  return (
    <Modal {...modalProps} title={t("WorkingTimeBookingDetails")}>
      {request ? (
        <>
          <WorkingTimeBookingStack withPerson booking={request} />
          <FormButtonGroup>
            <CancelButton onClick={modalProps.onClose} />
            <Button
              color="red"
              disabled={request.status === "Rejected"}
              onClick={async () => await handleUpdateStatus("Rejected")}
            >
              {t("Reject")}
            </Button>
            <Button
              disabled={request.status === "Approved"}
              onClick={async () => await handleUpdateStatus("Approved")}
            >
              {t("Approve")}
            </Button>
          </FormButtonGroup>
        </>
      ) : (
        <Alert color="red" title={t("Error")}>
          {t("WorkingTimeBooking_NoBookingSelected")}
        </Alert>
      )}
    </Modal>
  )
}
